import React, { useEffect } from "react";
import ReactDOM from "react-dom";

import { useMultiplierDataContext } from "@/store/MultiplierProvider";
import Button from "@/ui/Button/Button";
import Typography from "@/ui/Typography/Typography";

import { formatMultiplierDate } from "./utils";
import cls from "./celebration.module.scss";

const confettiPieces = Array.from({ length: 8 });

export const MultiplierCelebrationDialog = () => {
  const {
    multiplierInfo,
    multiplierCelebration,
    dismissMultiplierCelebration,
  } = useMultiplierDataContext();
  const isOpen = Boolean(multiplierInfo && multiplierCelebration);

  useEffect(() => {
    if (!isOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") dismissMultiplierCelebration();
    };
    document.addEventListener("keydown", closeOnEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [dismissMultiplierCelebration, isOpen]);

  if (!isOpen || !multiplierInfo || !multiplierCelebration) return null;

  const isExtended = multiplierCelebration === "extended";
  const { multiplier } = multiplierInfo.current;
  const expiresAt = formatMultiplierDate(multiplierInfo.current.expires_at);

  return ReactDOM.createPortal(
    <div
      className={cls.overlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="multiplier-celebration-title"
    >
      <div className={cls.glow} />
      <section className={cls.dialog}>
        {confettiPieces.map((_, index) => (
          <span key={index} className={cls.confetti} aria-hidden="true" />
        ))}

        <div className={cls.medallion}>×{multiplier}</div>
        <div className={cls.copy}>
          <Typography
            component="h2"
            id="multiplier-celebration-title"
            variant="h1"
          >
            Множитель ×{multiplier} {isExtended ? "продлён" : "включён"}!
          </Typography>
          <Typography>
            {isExtended
              ? "Ты снова выполнил условие — повышенный бонус продолжается без перерыва"
              : "Ты выполнил условие. Теперь бонусы за новых активных друзей увеличиваются автоматически"}
          </Typography>
        </div>

        {expiresAt && (
          <div className={cls.dateBox}>
            <span>
              <span aria-hidden="true">▣</span>
              {isExtended ? "МНОЖИТЕЛЬ ПРОДЛЁН ДО" : "МНОЖИТЕЛЬ ДЕЙСТВУЕТ ДО"}
            </span>
            <strong>{expiresAt}</strong>
          </div>
        )}

        <Button
          trigger="ref.multiplier.celebration_close"
          className={cls.confirmButton}
          label="Отлично"
          onClick={dismissMultiplierCelebration}
        />
      </section>
    </div>,
    document.body
  );
};
